<template>
    <div class="card_container" @click="goToPath" :class="{ 'pop-animate': isPopping }">
        <img :src="props.itemData.image" alt="" >
        <van-row class="bottom_part">
            <van-col span="15" class="text">
                <div>{{ $t(`activityName.${props.itemData.name}`) }}</div>
                <div v-if="props.itemData.unclaimed_count && props.itemData.unclaimed_count > 0" class="redPoint">{{
                    props.itemData.unclaimed_count }}
                </div>
            </van-col>
            <van-col span="9" class="button">
                <div class="pathBtn">
                    {{ $t('common.inprogress') }}
                </div>
            </van-col>
        </van-row>
    </div>
</template>

<script setup lang="ts">
import { playClickSound } from '@/utils/media';
import { goToRedirectPath, PromotionItem } from '@/view/promotion/supporrtScript';
import { ref, PropType } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter()
const props = defineProps({
    itemData: {
        type: Object as PropType<PromotionItem>,
        default: () => ({
            name: '',
            unclaimed_count: 0,
            image: '',
            icon: ''
        }),
        required: true
    }
})
const isPopping = ref(false)
const emits = defineEmits(["openAgentPopup", "openRedEnvelop", "goToHome"])
const goToPath = () => {
    goToRedirectPath(isPopping, props.itemData, router, emits, playClickSound)
}

</script>
<style scoped>
.card_container {
    border-radius: 15px 15px 10px 10px;
    overflow: hidden;
    margin: 10px 15px;
}

.card_container img {
    width: 100%;
    height: 150px;
    border-radius: 15px;
}

.bottom_part {
    margin-top: -3px;
    background: rgb(0, 35, 35);
    padding: 8px 15px;
}

.button {
    display: flex;
    justify-content: right;
    align-items: center;
}

.pathBtn {
    border: none;
    color: rgb(13, 176, 174);
    background: rgb(2, 78, 77);
    border-radius: 5px;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    margin: 5px 0;
}

.act_icon {
    background: linear-gradient(to bottom, rgba(240, 168, 83, 0.5), rgba(240, 168, 83, 0.04));
    border: 0.5px solid #DD7A33;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    padding: 5px;
    width: 25px;
}

.act_icon img {
    width: 25px;
}

.text {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
}

.redPoint {
    border-radius: 30px;
    background: #FF0000;
    border: 0.5px solid rgba(255, 255, 255, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-size: 9px;
    padding: 2px;
    width: 10px;
    margin-left: 5px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@media (max-width: 400px){
    .pathBtn{
        font-size: 13px;
    }
    .text{
        font-size: 16px;
    }
    .card_container img{
        height: 110px;
    }
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}
</style>